import { memo, useCallback } from 'react';
import { MenuItem, MenuList } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { shallowEqual } from 'react-redux';
import source from 'AurionCR/components/source';
import { setLanguage } from 'AurionCR/store/modules/language';
import style from './index.module.scss';
import clsx from 'clsx';

interface ILanguage {
  id: string;
  title: string;
  direction: number;
}

const apiLanguages =
  'Languages/GetAllDynamic?Select=id,title,direction&Filter=isActive==true&OrderBy=rank';
const apiLanguagesID = 'id';

const getLangLabel = (title: string) => {
  if (title === 'Hebrew') {
    return 'he';
  }

  if (title === 'English') {
    return 'en';
  }

  return '';
};

export const MenuLanguages = memo(() => {
  const dispatch = useAppDispatch();
  const languageID = useAppSelector((state: any) => state.language.languageID, shallowEqual);

  const languagesData = source(apiLanguages, apiLanguagesID, true);
  const languages = languagesData.data || [];

  const onChangeLanguage = useCallback(
    (language: ILanguage) => {
      return () => dispatch(setLanguage(language.id, language, language.direction));
    },
    [dispatch],
  );
  return (
    <MenuList className={style.root}>
      {languages.map((language: ILanguage) => {
        return (
          <MenuItem
            key={language.id}
            selected={language.id === languageID}
            className={clsx(style.item, language.id === languageID && style.active)}
            onClick={onChangeLanguage(language)}
            title={language.title || ''}
            disableRipple={language.id === languageID}
          >
            {getLangLabel(language.title)}
          </MenuItem>
        );
      })}
    </MenuList>
  );
});
